import { SchemaFormDefinition } from '@mews-commander/form';
import { compactArray } from '@mews/fp';
import { lt } from '@mews/framework';
import { PropertiesField } from './fields/Properties';
import { UsersField } from './fields/Users';
import { schema } from './schema';

const getCommonDefinition = (isEdit = false, currentWorkspaceEnterpriseIds: string[] = []) =>
    ({
        fields: {
            mewsBiWorkspaceId: {
                disabled: isEdit,
                label: lt('MewsBIWorkspaceId'),
            },
            enterpriseIds: {
                label: lt('MewsBIIntegrationFormPropertiesLabel'),
                render: (props) => (
                    <PropertiesField {...props} currentWorkspaceEnterpriseIds={currentWorkspaceEnterpriseIds} />
                ),
            },
            userIds: {
                label: lt('MewsBIIntegrationFormUsersLabel'),
                render: (props) => <UsersField {...props} disableCurrentUser={!isEdit} />,
            },
        },
    }) satisfies SchemaFormDefinition<typeof schema>;

export const getFormDefinition = (isPlatformAdmin: boolean) =>
    ({
        fields: {
            ...getCommonDefinition().fields,
        },
        renderFields: compactArray([isPlatformAdmin ? 'mewsBiWorkspaceId' : null, 'enterpriseIds', 'userIds']),
    }) satisfies SchemaFormDefinition<typeof schema>;

export const getUpdateFormDefinition = (isPlatformAdmin: boolean, currentWorkspaceEnterpriseIds: string[]) =>
    ({
        fields: {
            ...getCommonDefinition(true, currentWorkspaceEnterpriseIds).fields,
        },
        renderFields: compactArray([isPlatformAdmin ? 'mewsBiWorkspaceId' : null, 'enterpriseIds', 'userIds']),
    }) satisfies SchemaFormDefinition<typeof schema>;
